<template>
  <div class="standard-checkout-form">
    <standard-checkout-details :longPage="longPage" />

    <div class="card">
      <div class="card-title d-flex justify-content-between bg-light p-5">
        <div class="d-flex align-items-center">
          <span v-if="!longPage" class="circle-bread">1</span>
          <span v-if="!longPage" class="font-weight-bold text-description"
            >DADOS PESSOAIS</span
          >
          <i v-if="!longPage" class="icon-angle-right arrow"></i>
          <div
            class="d-flex align-items-center"
            :class="{
              'step-disabled': !longPage
            }"
          >
            <span v-if="!longPage" class="circle-bread">2</span>
            <span
              class="font-weight-bold  text-description"
              :class="{ 'text-secondary': !longPage }"
              >DADOS DE PAGAMENTO</span
            >
          </div>
        </div>
        <div class="d-flex align-items-center">
          <img src="@/assets/images/flags/brazil.png" class="pr-3" />
          <span class="font-weight-bold pr-3">Alterar país</span>
          <i class="icon-caret-down pr-3"></i>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex flex-wrap mb-6">
          <div class="col-lg-6 px-0 pr-lg-2">
            <form-group
              v-model="form.name"
              id="name"
              icon="user"
              label="Seu nome completo"
              type="text"
              placeholder="Ex: Jhon Doe"
              :errors="errors.name"
            />
          </div>

          <div class="col-lg-6 px-0 pl-lg-2">
            <form-group
              v-model="form.cpfCnpj"
              id="cpfCnpj"
              label="Seu CPF/CNPJ"
              type="text"
              mask="###.###.###.##"
              placeholder="Ex: 123.456.789-00"
              :errors="errors.cpfCnpj"
            />
          </div>

          <div class="col-lg-6 px-0 pr-lg-2">
            <form-group
              v-model="form.email"
              id="email"
              label="Seu e-mail"
              type="email"
              placeholder="Ex: jhondoe@email.com"
              :errors="errors.cpfCnpj"
            />
          </div>

          <div class="col-lg-6 px-0 pl-lg-2">
            <form-group
              v-model="form.emailCheck"
              id="emailCheck"
              label="Confirme seu e-mail"
              type="email"
              placeholder="Ex: jhondoe@email.com"
              :errors="errors.cpfCnpj"
            />
          </div>
        </div>

        <div v-if="longPage" class="row mb-6">
          <div class="col-12 payment-type-selector d-flex p-5">
            <button
              type="button"
              class="btn current"
              @click="$emit('input', 'card')"
            >
              <i class="icon-credit-card"></i>
              Cartão
            </button>
            <button type="button" class="btn" @click="$emit('input', 'pix')">
              <i class="icon-pix"></i>
              Pix
            </button>
            <button type="button" class="btn" @click="$emit('input', 'billet')">
              <i class="icon-bar-code"></i>
              Boleto
            </button>
          </div>
          <div class="col-lg-12">
            <form-group
              v-model="form.number"
              id="number"
              icon="user"
              label="Número do cartão"
              type="text"
              mask="#### #### #### ####"
              placeholder="Ex: 1234 5678 1234 5678"
              :errors="errors.number"
            />
            <div class="row">
              <div class="col-lg-6">
                <form-group
                  v-model="form.mm"
                  label="Data de validade"
                  id="mm"
                  icon="user"
                  type="text"
                  mask="## / ####"
                  placeholder="MM / AAAA"
                  :errors="errors.mm"
                />
              </div>
              <div class="col-lg-6" v-click-outside="closeHelp">
                <label for="cvv" class="cvv-label">
                  Código de segurança
                  <button
                    type="button"
                    class="help-button"
                    @click="cvvHelp = true"
                  >
                    <i class="icon-help"></i>
                  </button>
                </label>
                <cvv-help v-if="cvvHelp" />
                <form-group
                  v-model="form.cvv"
                  id="cvv"
                  class="cvv-input"
                  icon="user"
                  type="text"
                  mask="###"
                  placeholder="Ex: 123"
                  :errors="errors.cvv"
                />
              </div>
              <div class="col-lg-12">
                <form-group
                  v-model="form.installments"
                  id="installments"
                  class="installments"
                  icon="user"
                  label="Opcões de parcelamento"
                  type="text"
                  select
                  disabled
                  :options="[{ id: '', name: '12 x R$ 44* ' }]"
                  :errors="errors.cvv"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="card-footer d-flex align-items-center flex-column flex-lg-row justify-content-center justify-content-lg-between bg-white pt-2 pt-lg-5"
        >
          <div id="checkout-notes">
            <small class="fs-10"
              >Ao continuar, você concorda com os <a>termos de uso</a> e
              <a>políticas de privacidade</a></small
            >
            <br />
            <small class="fs-10">*parcelamento com acréscimo</small>
          </div>
          <img
            class="d-none img-fluid small-logo"
            :src="$config.get('logo_black')"
          />
          <button class="btn btn-success fs-16 text-uppercase px-6">
            <div v-if="!longPage">Próximo Passo</div>
            <div v-else>Pagar agora</div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import vClickOutside from "v-click-outside";
import { mapState } from "vuex";
import CvvHelp from "./CvvHelp.vue";
import StandardCheckoutDetails from "./StandardCheckoutDetails";

export default {
  props: ["longPage"],
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: { StandardCheckoutDetails, CvvHelp },
  data() {
    return {
      ...formFields([
        "name",
        "cpfCnpj",
        "email",
        "emailCheck",
        "number",
        "installments"
      ]),
      cvvHelp: false
    };
  },
  methods: {
    closeHelp() {
      this.cvvHelp = false;
    }
  },
  computed: {
    ...mapState("product", ["product"])
  }
};
</script>

<style lang="scss" scoped>
.standard-checkout-form {
  ::v-deep .form-control {
    font-weight: 500 !important;
    border-radius: 6px !important;
  }
  .btn {
    white-space: nowrap;
    &.btn-success {
      background-color: #7fcf69;
      border: 1px solid #7fcf69;
      border-radius: 6px;
    }
  }

  a {
    color: #2178fb;
    text-decoration: none;
    background-color: transparent;
  }

  .help-button {
    padding: 0;
    border: 0;
    background: 0 0;
  }

  label,
  ::v-deep .form-group > label {
    font-weight: 700;
    font-size: 12px;
    line-height: 17px;
    color: #909398;
    margin-bottom: 5px;
  }

  .card {
    border-radius: 16px;
    overflow: hidden;
  }

  .card-title {
    margin-bottom: unset;
  }

  .card-footer {
    border-top: unset;
    padding: 0;
  }

  .text-description {
    font-size: 12px;
  }

  .circle-bread {
    background-color: #d2d0d8;
    padding: 1px;
    min-width: 24px;
    max-width: 24px;
    min-height: 24px;
    max-height: 24px;
    border-radius: 24px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    margin-right: 8px;
  }

  .step-disabled {
    filter: opacity(0.4);
  }
  .arrow {
    padding-left: 16px;
    padding-right: 16px;
    font-size: 24px;
  }

  ::v-deep .standard-checkout-details {
    display: none;
  }

  .preview-credit-card {
    background: rgba(33, 38, 49, 0.05);
    border: 1px solid rgba(33, 38, 49, 0.1);
    border-radius: 16px;
    box-sizing: border-box;
    padding: 60px 24px 16px;
    letter-spacing: 0.16em;
    font-weight: 700;
    font-size: 17px;
    line-height: 23px;
    font-family: monospace;
    color: #979797;
    max-width: 400px;
  }

  .payment-type-selector {
    button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      border: 1px solid rgba(33, 38, 49, 0.4);
      color: rgba(33, 38, 49, 0.4);
      padding: 8px;
      width: 120px;
      font-size: 12px;
      line-height: 16px;
      margin-right: 16px;

      i {
        font-size: 24px;
        margin-bottom: 2px;
      }

      &.current {
        border-color: #2178fb;
        color: #2178fb;
        font-weight: bold;
      }
    }
  }
  .cvv-label {
    margin-top: 13px;
  }
  .cvv-input {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .installments {
    ::v-deep .el-input.is-disabled .el-input__inner {
      color: #495057;
      font-weight: 500;
      background: transparent;
      border-radius: 6px !important;
      border: 1px solid #e1e1e1;
    }
  }
  .small-logo {
    max-height: 20px;
    margin: 8px 0;
    filter: grayscale(100%);
    opacity: 0.3;
  }
}
</style>
